export default __webpack_public_path__ + "media/images/playpass_logo_sm-79e810e1e8ddbddc938c976a4cce620a.png";